import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  return {
    defaultChatBox: {
      width: 450,
      flex: "1 1 auto",
      maxHeight: "700px",
      padding: 10,
      paddingTop: 5,
      boxSizing: "border-box"
    },
    Title: {
      borderBottom: "thin solid",
      borderBottomColor: theme.palette.divider,
      paddingBottom: 5
    },
    Messages: {
      marginLeft: "10px",
      marginRight: "10px",
      maxHeight: "450px",
      overflowY: "auto"
    },
    Form: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "end"
    },
    textField: {
      flexGrow: 1,
      marginRight: theme.spacing(1)
    },
    submit: {
      flexShrink: 0,
      textTransform: "none",
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.getContrastText(theme.palette.primary.dark)
    }
  }
});
